
<template>
  <div v-resize="onResize" id="detail-dialog">
    <div
      class="d-dialog"
      :style="{
        padding: windowSize < 600 ? '10px 5px 10px 0px' : '25px 25px 15px 25px'
      }"
    >
      <div style="width: 100%; display: flex">
        <div
          :style="{
            padding:
              windowSize < 600 ? '10px 10px 0px 10px' : '0px 0px 0px 5px',
            width: '70%'
          }"
        >
          <div class="btn-filter">Order Detail</div>
        </div>
        <div
          :style="{
            padding: windowSize < 600 ? '15px 2px 0px 0px' : '5px 5px 0px 0px',
            'text-align': 'end',
            width: '30%'
          }"
          @click="close()"
        >
          <v-icon
            v-text="'mdi-close'"
            style="color: #000000; cursor: pointer"
            size="24"
          ></v-icon>
        </div>
      </div>
      <div class="smaill-body">
        <!-- <div style="width:100%;padding:13px 0px 10px 20px">
          <div class="d-dialog-title">หมายเลขคำสั่งซื้อ</div>
          <div class="d-dialog-value">{{ data.purchase_id }}</div>
        </div> -->
        <div style="width: 100%; padding: 0px 20px">
          <!------------------>
          <div
            :style="{
              width: '100%',
              'padding-top': '6px',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px',
                'padding-top': windowSize < 600 ? '8px' : '10px'
              }"
            >
              <div
                class="d-dialog-title desc"
                :style="{
                  width: windowSize < 600 ? '100%' : '40%',
                  'padding-bottom': windowSize < 600 ? '10px' : '13px'
                }"
              >
                <div class="d-dialog-title">หมายเลขคำสั่งซื้อ</div>
                <div class="d-dialog-value">{{ data.purchase_id }}</div>
              </div>
            </div>
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? '' : 'flex'
              }"
            >
              <div
                :style="{
                  width: '100%',
                  'padding-top': windowSize < 600 ? '0px' : '25px'
                }"
              >
                <div style="width: 100%; display: flex; padding-top: 7px">
                  <div
                    class="d-dialog-title desc"
                    :style="{
                      width: windowSize < 600 ? '40%' : '30%',
                      'padding-bottom': windowSize < 600 ? '0px' : '0px',
                      'text-align': windowSize < 600 ? 'left' : 'right'
                    }"
                  >
                    วันที่สั่งซื้อ
                  </div>
                  <div
                    class="d-dialog-title"
                    :style="{
                      width: windowSize < 600 ? '60%' : '70%'
                    }"
                  >
                    {{ formatDate(data.order_date) }}
                  </div>
                </div>
                <div style="width: 100%; display: flex; padding-top: 7px">
                  <div
                    class="d-dialog-title desc"
                    :style="{
                      width: windowSize < 600 ? '40%' : '30%',
                      'padding-bottom': windowSize < 600 ? '0px' : '0px',
                      'text-align': windowSize < 600 ? 'left' : 'right'
                    }"
                  >
                    จะต้องจัดส่งภายใน
                  </div>
                  <div
                    class="d-dialog-title"
                    :style="{
                      width: windowSize < 600 ? '60%' : '70%'
                    }"
                  >
                    {{ formatDate(data.order_delivery_due_date) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!------------------>
          <div
            :style="{
              width: '100%',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '10px' : '0px'
                }"
              >
                ชื่อผู้ผลิต
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'padding-right': windowSize < 600 ? '10px' : '0px'
                }"
              >
                {{ data.sup_name }} {{ data.sup_surname }}
              </div>
            </div>
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'text-align': windowSize < 600 ? 'left' : 'right'
                }"
              >
                วันที่จัดส่ง
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%'
                }"
              >
                {{ formatDate(data.order_delivery_date) }}
              </div>
            </div>
          </div>
          <!------------------>
          <div
            :style="{
              width: '100%',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px',
                'padding-top': '6px'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '10px' : '0px'
                }"
              >
                ชื่อบริษัทผู้ขาย
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'padding-right': windowSize < 600 ? '10px' : '0px'
                }"
              >
                {{ data.seller_name }}
              </div>
            </div>
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'padding-top': '6px',
                  'text-align': windowSize < 600 ? 'left' : 'right'
                }"
                
              >
                จัดส่งโดย
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-top': '6px'
                }"
                v-if="showShipping"
              >
                 {{ data.shipping_channel === 'OWN_FLEET' || data.shipping_channel === 'BS_EXPRESS' ?  data.shipping_name : data.shipping_name }}
              </div>
            </div>
          </div>
          <!------------------>
          <div
            :style="{
              width: '100%',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px',
                'padding-top': '6px'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '10px' : '0px'
                }"
              >
                ชื่อลูกค้า
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'padding-right': windowSize < 600 ? '10px' : '0px'
                }"
              >
                {{ data.cus_name }} {{ data.cus_surname }}
              </div>
            </div>

            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'padding-top': '6px',
                  'text-align': windowSize < 600 ? 'left' : 'right'
                }"
              >
                เลขพัสดุ
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-top': '6px'
                }"
              >
                {{ data.tracking_code || '' }}
              </div>
            </div>
          </div>
          <!------------------>
          <!-- <div
            v-if="data.change_address == 1"
            :style="{
              width: '100%',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px',
                'padding-top': '6px'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '10px' : '0px'
                }"
              >
                ชื่อผู้รับ
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px',
                  'padding-right': windowSize < 600 ? '10px' : '0px'
                }"
              >
                {{ data.seller_name }} {{ data.seller_surname }}
              </div>
            </div>
          </div> -->

          <div
            :style="{
              width: '100%',
              'padding-top': '6px',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px'
              }"
            >
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '0px' : '0px'
                }"
              >
                ที่อยู่
              </div>
              <div
                :class="'d-dialog-title'"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '5px' : '0px'
                }"
              >
                {{
                  data.change_address == 0
                    ? data.cus_address +
                      ' ' +
                      data.cus_subdistrict +
                      ' ' +
                      data.cus_district +
                      ' ' +
                      data.cus_province +
                      ' ' +
                      data.cus_postal
                    : data.seller_address
                }}
                <!-- {{ data.cus_address }} -->
              </div>
            </div>
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? '' : 'flex'
              }"
            >
              <div style="width: 100%">
                <div style="width: 100%; display: flex">
                  <div
                    :class="
                      windowSize < 800
                        ? 'd-dialog-title'
                        : 'd-dialog-title desc'
                    "
                    :style="{
                      width: windowSize < 600 ? '40%' : '30%',
                      'padding-bottom': windowSize < 600 ? '0px' : '0px',
                      'text-align': windowSize < 600 ? 'left' : 'right'
                    }"
                  >
                    วันที่ส่งสำเร็จ
                  </div>
                  <div
                    class="d-dialog-title"
                    :style="{
                      width: windowSize < 600 ? '60%' : '70%'
                    }"
                  >
                    {{ formatDate(data.order_success_date) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!------------------>
          <div
            :style="{
              width: '100%',
              'padding-top': '6px',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px'
              }"
            >
              <div
                class="d-dialog-title desc"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '10px' : '0px'
                }"
              >
                เบอร์โทรศัพท์
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '5px' : '0px'
                }"
              >
                {{data.cus_phone || ''}}
              </div>
            </div>
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? '' : 'flex'
              }"
            >
              <div style="width: 100%">
                <div style="width: 100%; display: flex">
                  <div
                    class="d-dialog-title desc"
                    :style="{
                      width: windowSize < 600 ? '40%' : '30%',
                      'padding-bottom': windowSize < 600 ? '0px' : '0px',
                      'text-align': windowSize < 600 ? 'left' : 'right'
                    }"
                  >
                    หมายเหตุ
                  </div>
                  <div
                    class="d-dialog-title"
                    :style="{
                      width: windowSize < 600 ? '60%' : '70%'
                    }"
                  >
                   {{ data.order_remarks }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :style="{
              width: '100%',
              'padding-top': '6px',
              display: windowSize < 600 ? '' : 'flex'
            }"
          >
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? 'flex' : 'flex',
                'padding-bottom': windowSize < 600 ? '0px' : '0px'
              }"
            >
              <div
                class="d-dialog-title desc"
                :style="{
                  width: windowSize < 600 ? '40%' : '30%',
                  'padding-bottom': windowSize < 600 ? '10px' : '0px'
                }"
              >
                สถานะ
              </div>
              <div
                class="d-dialog-title"
                :style="{
                  width: windowSize < 600 ? '60%' : '70%',
                  'padding-bottom': windowSize < 600 ? '5px' : '0px'
                }"
              >
                {{ data.order_status }}
              </div>
            </div>
            <div
              :style="{
                width: windowSize < 600 ? '100%' : '50%',
                display: windowSize < 600 ? '' : 'flex'
              }"
            >
              <div style="width: 100%">
                <div style="width: 100%; display: flex">
                  <div
                    class="d-dialog-title desc"
                    :style="{
                      width: windowSize < 600 ? '40%' : '30%',
                      'padding-bottom': windowSize < 600 ? '0px' : '0px',
                      'text-align': windowSize < 600 ? 'left' : 'right'
                    }"
                  >
                    เอกสารใบ invoice
                  </div>
                  <div style="height: 30px; display: flex; justify-content: center">
                    <div
                      :style="{
                        border: file_error ? '1px solid red' : '1px solid #D9D9D9'
                      }"
                      style="
                        font-family: 'Bai Jamjuree', sans-serif;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        border-radius: 8px;
                        background-color: #ffff;
                        width: 150px;
                      "
                    >
                      <div style="width: 100%">
                        <!-- ปรับตรงนี้ -->
                        <div v-if="image || data.inv_purchase_file" style="display: flex; align-items: center;">
                          <a
                            v-if="image || data.inv_purchase_file"
                            href="javascript:void(0)"
                            @click="downloadInvoiceFile"
                            style="
                              color:#1976D2;
                              text-decoration:underline;
                              font-size:14px;
                              margin-left: 6px;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 110px;
                              display: inline-block;
                              vertical-align: middle;
                            "
                            :title="data.inv_purchase_file ? data.inv_purchase_file : (image ? image.name : '')"
                          >
                            {{ data.inv_purchase_file ? data.inv_purchase_file : (image ? image.name : '') }}
                          </a>
                          
                        </div>
                        <div v-else class="file_input_wrap" @click="dialogInvoice = true" style="cursor:pointer;">
                          <label
                            style="
                              white-space: nowrap;
                              width: 100%;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              font-size: 14px;
                            "
                            class="btn btn-large"
                          >
                            <span class="mdi-rotate-315 mdi mdi-attachment"></span>
                            เพิ่มไฟล์
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!------------------>
          <div
            class="d-table"
            :style="{
              'padding-top': windowSize < 600 ? '10px' : '15px'
            }"
          >
            <div class="d-head" v-if="windowSize >= 600">
              <div style="width: 3%; text-align: center">
                {{ headColum[0] }}
              </div>
              <div style="width: 10%; padding-left: 20px">
                {{ headColum[1] }}
              </div>
              <div style="width: 47%; padding-left: 10px">
                {{ headColum[2] }}
              </div>
              <div style="width: 10%; text-align: center; padding-left: 5px">
                {{ headColum[3] }}
              </div>
              <div style="width: 30%; padding-left: 17px">
                {{ headColum[4] }}
              </div>
            </div>
            <div class="d-body">
              <div
                class="d-body-row"
                v-for="(row, index) in data.items"
                :key="index + row.index"
                :style="{
                  'border-radius': renderBorder(index),
                  'border-top':
                    index == 0 ? '0.7px solid rgba(0, 0, 0, 0.2)' : '',
                  display: windowSize < 600 ? 'block' : 'flex',
                  padding: windowSize < 600 ? '0px 10px 0px 0px' : '8px 20px'
                }"
              >
                <div
                  :style="{
                    width: windowSize < 600 ? '100%' : '3%',
                    'text-align': windowSize < 600 ? 'left' : 'center'
                  }"
                >
                  <div style="width: 100%; display: flex">
                    <div class="small-row-title" v-if="windowSize < 600">
                      {{ headColum[0] }}
                    </div>
                    <div
                      class="small-row-value"
                      :style="{ width: windowSize < 600 ? '60%' : '100%' }"
                    >
                      {{ index + 1 }}
                    </div>
                  </div>
                </div>
                <div
                  :style="{
                    width: windowSize < 600 ? '100%' : '10%',
                    'padding-left': windowSize < 600 ? '0px' : '10px'
                  }"
                >
                  <div style="width: 100%; display: flex">
                    <div class="small-row-title" v-if="windowSize < 600">
                      {{ headColum[1] }}
                    </div>
                    <div
                      class="small-row-value"
                      :style="{ width: windowSize < 600 ? '60%' : '100%' }"
                    >
                      {{ row.product_sku }}
                    </div>
                  </div>
                </div>
                <div
                  :style="{
                    width: windowSize < 600 ? '100%' : '47%',
                    'padding-right': windowSize < 600 ? '0px' : '10px'
                  }"
                >
                  <div style="width: 100%; display: flex">
                    <div class="small-row-title" v-if="windowSize < 600">
                      {{ headColum[2] }}
                    </div>
                    <div
                      class="small-row-value"
                      :style="{ width: windowSize < 600 ? '60%' : '100%' }"
                    >
                      {{ row.product_name }}
                    </div>
                  </div>
                </div>
                <div
                  :style="{
                    width: windowSize < 600 ? '100%' : '10%'
                  }"
                >
                  <div style="width: 100%; display: flex">
                    <div class="small-row-title" v-if="windowSize < 600">
                      {{ headColum[3] }}
                    </div>
                    <div
                      class="small-row-value"
                      :style="{
                        'text-align': windowSize < 600 ? 'left' : 'center',
                        width: windowSize < 600 ? '60%' : '100%'
                      }"
                    >
                      {{ currency(row.order_qty) }}
                    </div>
                  </div>
                </div>
                <div
                  :style="{
                    width: windowSize < 600 ? '100%' : '30%',
                    'padding-right': windowSize < 600 ? '0px' : '10px',
                    'padding-left': windowSize < 600 ? '' : '10px'
                  }"
                >
                  <div style="width: 100%; display: flex">
                    <div class="small-row-title" v-if="windowSize < 600">
                      {{ headColum[4] }}
                    </div>
                    <div
                      class="small-row-value"
                      :style="{ width: windowSize < 600 ? '60%' : '100%' }"
                    >
                      {{ row.order_detail_remark }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-dialog-action">
        <div
          @click="printIcon()"
          style="padding-right: 25px; padding-top: 8px"
          v-if=" data.order_status == 'Delivery'"
        >
          <v-icon
            v-text="'mdi-printer'"
            style="color: #000000; cursor: pointer"
            size="20"
          ></v-icon>
        </div>
          <v-btn
            rounded
            @click="mainAction"
            class="ok"
            v-if="renderBtn !== ''"
          >
            {{ renderBtn }}
          </v-btn>
        <!-- <v-btn rounded @click="accept()" class="ok" v-if="renderBtn() !== ''">{{
          renderBtn()
        }}</v-btn> -->
      </div>
    </div>

    <v-dialog
      v-model="dialogBookingError"
      persistent
      max-width="400"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/bookingerror.png" />
            </div>
            <div style="padding: 0px 20px; font-size: 14px;
                font-family: 'Bai Jamjuree', sans-serif;
                font-size: 16px; text-align: center; #333">
              ไม่สามารถ booking ได้ กรุณาตรวจสอบข้อมูลอีกครั้ง<br>
              <span style="font-size: 14px; color: #d32f2f; font-family: 'Bai Jamjuree', sans-serif;">
                message error : {{ bookingErrorMsg }}
              </span>
            </div>
          </div>
          <div class="bg-confirm-action" style="text-align: center;">
            <v-btn rounded
              color="#333"
              style="margin-left: 12px ; color: white; font-family: 'Bai Jamjuree';" @click="dialogBookingError = false">ตกลง</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogBookingSuccess"
      persistent
      max-width="400"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/success.png" style="width: 100px; height: 100px;" />
            </div>
            <div style="padding: 0px 20px; font-size: 14px; font-family: 'Bai Jamjuree', sans-serif; text-align: center;">
              กรุณาพิมพ์ใบปะหน้า และรอขนส่งเข้ารับพัสดุของคุณ<br>
              <span style="font-size: 14px; color: #333;">
                {{ bookingSuccessMsg }}
              </span>
            </div>
          </div>
          <div class="bg-confirm-action" style="text-align: center;">
            <v-btn
              color="#333"
              style="margin-left: 12px ; color: white; font-family: 'Bai Jamjuree';" @click="dialogBookingSuccess = false">ตกลง</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showBsLabelDialog" max-width="500" persistent>
        <v-card class="rounded-xl pa-4" style="border-radius: 20px;">
          <!-- Header -->
          <v-card-title class="d-flex justify-space-between align-center pa-0 mb-4 w-100">
            <div
              class="text-subtitle-1 font-weight-medium"
              style="background-color: #fff; border-radius: 30px; padding: 6px 20px; border: 1px solid #000; font-family: 'Bai Jamjuree';"
            >
              ใบปะหน้าทั้งหมด
            </div>
            <v-btn icon @click="showBsLabelDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0">
            <div
              style="width:100%; display: flex; font-weight: bold; background-color: #EDF0FF; border-radius: 8px; padding: 8px 0; margin-bottom: 6px;"
            >
              <div style="width:40px; text-align:center; padding-left: 25px;">#</div>
              <div style="flex:1; text-align:left; text-align:center;">เลขพัสดุ</div>
              <div style="width:60px; text-align:center;"></div>
            </div>

            <v-list-item
              v-for="(fileObj, idx) in bsLabelFiles"
              :key="idx"
            >
              <div style="width:40px; text-align:center; font-weight:600;">{{ idx + 1 }}</div>
              <div style="flex:1; font-family: 'Bai Jamjuree';">
                {{ fileObj.tracking_code || '-' }}
              </div>
              <div style="width:60px; text-align:center;">
                <v-icon size="22" @click="printBsLabelFile(fileObj)">mdi-printer</v-icon>
              </div>
            </v-list-item>
          </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNoShipment"
      persistent
      max-width="450"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/addshipment.png" style="width: 175px; height: 102px;" />
            </div>
            <div
              style="
                padding: 0px 20px; 
                text-align: center; 
                font-size: 14px;
                font-family: 'Bai Jamjuree', sans-serif;
                font-size: 16px;
                padding: 0 0 20px 0;
                margin-top: 3rem;
              "
            >
              กรุณาใส่ที่อยู่การจัดส่งสินค้าก่อน ไปยังเมนู
              <span
                style="font-weight:bold; color:#1976D2; cursor:pointer; text-decoration:underline;"
                @click="goToUserProfile"
              >เพิ่มที่อยู่จัดส่ง</span>
            </div>
          </div>
          <div class="bg-confirm-action" style="text-align: center;">
            <v-btn
              rounded
              color="#333"
              style="margin-left: 12px ; color: white; font-family: 'Bai Jamjuree';"
              @click="dialogNoShipment = false"
            >ตกลง</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInvoice" max-width="500" persistent>
      <v-card class="rounded-xl pa-6" style="border-radius: 30px;">
        <v-card-title class="d-flex justify-space-between align-center pa-0 mb-4 w-100">
          <div class="text-h6 font-weight-medium" style=" background-color: #EDF0FF; border-radius: 30px; padding: 8px 24px; border: 2px solid #ccc;">
            <div style="font-family: 'Bai Jamjuree';">แนบเอกสาร</div>
          </div>
          <v-btn icon @click="closeInvoiceDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-0 w-100">
          <div style="font-family: 'Bai Jamjuree'; margin-bottom: 8px;">
            เอกสารใบ invoice <span style="color:red">*</span>
          </div>
          <div
            class="d-flex flex-column align-center justify-center w-100"
            style="border: 2px dashed #ccc; border-radius: 16px; height: 200px; cursor: pointer; text-align: center;"
            @click="$refs.invoiceFileInput.click()"
          >
            <template v-if="!invoiceFile">
              <div class="text-subtitle-2 mb-2">
                Drop your file(s) here, or <span style="color:#1976D2;">Browse</span>
              </div>
              <div class="text-caption">รองรับไฟล์: .png, .pdf, .jpg, .jpeg และ .zip</div>
              <div class="text-caption">ขนาดไม่เกิน 2 MB.</div>
            </template>
            <div v-else class="mt-2 text-center" style="width:100%; height: 100%;">
              <img
                v-if="isImageFile(invoiceFile)"
                :src="invoicePreview"
                alt="preview"
                style="max-width: 100%; max-height: 120px; margin-bottom: 6px;"
              />
              <div v-else-if="isPdfFile(invoiceFile)">
                <iframe
                  :src="invoicePreview"
                  style="width: 100%; height: 100%; border: none; margin-bottom: 6px;"
                ></iframe>
                <!-- <a
                  :href="invoicePreview"
                  target="_blank"
                  rel="noopener"
                  style="font-size:13px; color:#1976D2; text-decoration:underline; cursor:pointer;"
                  download
                >
                  {{ invoiceFile.name }}
                </a> -->
              </div>
              <div v-else-if="isZipFile(invoiceFile)">
                <v-icon color="blue darken-2" size="36">mdi-folder-zip</v-icon>
                <a
                  :href="invoicePreview"
                  target="_blank"
                  rel="noopener"
                  style="font-size:13px; color:#1976D2; text-decoration:underline; cursor:pointer;"
                  download
                >
                  {{ invoiceFile.name }}
                </a>
              </div>
              <div v-else>
                <v-icon size="32">mdi-file</v-icon>
                <a
                  :href="invoicePreview"
                  target="_blank"
                  rel="noopener"
                  style="font-size:13px; color:#1976D2; text-decoration:underline; cursor:pointer;"
                  download
                >
                  {{ invoiceFile.name }}
                </a>
              </div>
            </div>
            <input
              ref="invoiceFileInput"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.zip"
              @change="onInvoiceFileChange"
              style="display: none;"
            />
          </div>
          <div v-if="invoiceError" style="color: red; font-size: 13px;" class="mt-2">{{ invoiceError }}</div>
        </v-card-text>
        <v-card-actions class="justify-end pt-6 px-0">
          <v-btn
            color="black"
            class="rounded-lg"
            style="color: white; font-family: 'Bai Jamjuree'; width: 100%; font-size: 16px;"
            @click="saveInvoiceFile"
            :disabled="!invoiceFile || loadding_upload_image"
            :loading="loadding_upload_image"
          >
            {{ loadding_upload_image ? 'อัปโหลด...' : 'บันทึก' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      persistent
      v-model="confirmDialog"
      max-width="500"
      :width="data.order_status == 'Delivering' ? 600 : 500"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align: center">
              <img
                v-if="confirmPrint"
                class="img"
                src="@/assets/images/other.png"
              />
              <img v-else class="img" src="@/assets/images/confrim.png" />
            </div>
            <div
              style="font-family: 'Bai Jamjuree', sans-serif; padding: 0px 20px"
            >
              {{ confirmText }}
            </div>
          </div>
          <div class="bg-confirm-action">
            <div
              class="bg-confirm-action-action"
              :style="{ display: windowSize < 600 ? 'grid' : 'flex', 'pointer-events': 'none' }"
              v-if="data.order_status == 'Delivering'"
            >
              <div style="display: flex; margin-right: 25px">
                <div :class="radio == 'customer' ? 'd-ratio selected' : 'd-ratio'"></div>
                <div class="d-v-label">พัสดุการนำจ่ายถึงลูกค้า</div>
              </div>
              <div style="display: flex">
                <div :class="radio == 'supply' ? 'd-ratio selected' : 'd-ratio'"></div>
                <div class="d-v-label">พัสดุส่งกลับผู้ขาย</div>
              </div>
            </div>
            <div>
              <v-btn
                rounded
                @click="submit()"
                class="ok"
                style="margin-right: 45px"
                :loading="loadding_shippop_booking"
                :disabled="loadding_shippop_booking"
                >{{ loadding_shippop_booking ? 'Loading...' : confirmBtn }}</v-btn
              > 
              <v-btn rounded @click="cancel()" class="clear">ไม่</v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    

    <v-dialog
      persistent
      v-model="confirmDialog_print"
      max-width="500"
      :width="data.order_status == 'Delivering' ? 600 : 500"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/other.png" />
            </div>
            <div style="padding: 0px 20px">{{ confirmText_print }}</div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                rounded
                @click="submit_print(data)"
                class="ok"
                style="color: #fff; margin-right: 45px"
              >
                ใช่
              </v-btn>
              <v-btn rounded @click="confirmDialog_print = false" class="clear"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="DialogShipping"
      max-width="500"
      :width="data.order_status == 'Delivering' ? 600 : 500"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div
              style="
                padding: 20px 0 0 0;
                font-size: 20px;
                font-family: 'Bai Jamjuree', sans-serif;
                text-align: center;
              "
            >
              รายละเอียดพัสดุสินค้า
            </div>

            <div style="width: 100%">
              <div
                class=""
                style="
                  font-family: 'Bai Jamjuree', sans-serif;
                  width: 67%;
                  padding: 20px 0 10px 0;
                "
              >
                บริษัทขนส่ง <span style="color: red">*</span>
              </div>
              <div style="display: flex; justify-content: center">
                <v-select
                  class="select_ disabled-select"
                  disabled
                  color="grey"
                  background-color="#f5f5f5"
                  :label="data.shipping_name || '- ไม่พบข้อมูลบริษัทขนส่ง -'"
                  style="
                    font-family: 'Bai Jamjuree', sans-serif;
                    max-width: 50%;
                    background-color: #f5f5f5 !important;
                  "
                  solo
                  dense
                  :value="data.shipping_name"
                  :items="[{shipping_name: data.shipping_name}]"
                  :item-text="item => item.shipping_name"
                  :item-value="item => item.shipping_name"
                >
                </v-select>
              </div>
              <div
                style="
                  color: #da0707;
                  font-family: 'Bai Jamjuree', sans-serif;
                  font-size: 14px;
                  width: 77%;
                "
                v-if="this.Error.errorShipping != ''"
                class="txt-wrong"
              >
                {{ this.Error.errorShipping_txt }}
              </div>
              <div
                v-if="loadding_shipping"
                style="padding: 0 0 0 40%; z-index: 1; position: absolute"
              >
                <v-progress-circular
                  :size="100"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  width: 100%;
                  overflow: visible;
                "
              >
                <div
                  style="
                    width: 50%;
                    max-width: 100%;
                    text-align: left;
                    overflow: visible;
                    box-sizing: border-box;
                  "
                >
                  <div
                    style="
                      font-family: 'Bai Jamjuree', sans-serif;
                      padding: 20px 0 10px 0;
                    "
                  >
                    เลขพัสดุ <span style="color: red">*</span>
                  </div>
                  <div class="shipping-tracking-input-wrap">
                    <v-text-field
                      v-model="shipping_number"
                      class="shipping-tracking-field"
                      :error="!!Error.errorTracking_txt"
                      hide-details
                      @input="clearTrackingNumberError"
                      style="font-family: 'Bai Jamjuree', sans-serif;"
                      solo
                      dense
                    >
                      <v-icon
                        @click="clear_shipping_number"
                        v-if="(shipping_number || '').length != 0"
                        slot="append"
                        size="18"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                  </div>
                  <div
                    v-if="Error.errorTracking_txt"
                    style="
                      margin-top: 8px;
                      padding-bottom: 4px;
                      text-align: start;
                      color: #da0707;
                      font-family: 'Bai Jamjuree', sans-serif;
                      font-size: 10px;
                      line-height: 1.35;
                      word-break: break-word;
                    "
                    class="txt-wrong"
                  >
                    {{ Error.errorTracking_txt }}
                  </div>
                </div>
              </div>

              <div
                style="display: flex; justify-content: center; width: 100%;"
              >
                <div
                  style="
                    width: 50%;
                    max-width: 100%;
                    text-align: left;
                    box-sizing: border-box;
                  "
                >
                  <div
                    style="
                      font-family: 'Bai Jamjuree', sans-serif;
                      padding: 20px 0 10px 0;
                    "
                  >
                    เอกสารใบ invoice
                    <span style="color: red">*</span>
                  </div>
                </div>
              </div>
              <div style="height: 30px; display: flex; justify-content: center">
                <div
                  :style="{
                    border: file_error ? '1px solid red' : '1px solid #D9D9D9'
                  }"
                  style="
                    font-family: 'Bai Jamjuree', sans-serif;
                    align-items: center;
                    display: flex;
                    justify-content: center;
                    border-radius: 8px;
                    background-color: #ffff;
                    width: 50%;
                  "
                >
                  <div style="width: 85%">
                    <div class="file_input_wrap">
                      <input
                        type="file"
                        accept=".zip,.pdf, .jpg, .jpeg, .png, .rar, .7z"
                        @change="previewImage"
                        name="imageUpload"
                        id="imageUpload"
                        class="hide"
                      />
                      <label
                        style="
                          white-space: nowrap;
                          width: 100%;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          font-size: 14px;
                        "
                        for="imageUpload"
                        class="btn btn-large"
                      >
                        <span
                          v-if="image == null"
                          class="mdi-rotate-315 mdi mdi-attachment"
                        ></span
                        >{{ image == null ? 'เพิ่มไฟล์' : image.name }}
                      </label>
                    </div>
                  </div>
                  <v-icon
                    @click="clear_image"
                    v-if="image != null"
                    style="cursor: pointer"
                    slot="append"
                    size="18"
                  >
                    mdi-close
                  </v-icon>
                </div>
              </div>

              <div style="display: flex; justify-content: center">
                <div
                  v-if="file_error"
                  style="
                    text-align: start;
                    color: #da0707;
                    font-family: 'Bai Jamjuree', sans-serif;
                    font-size: 10px;
                    width: 50%;
                  "
                  class="txt-wrong"
                >
                  {{ this.Error.errorImg_txt }}
                  <!-- {{ this.$t('txt-wrong21') }} -->
                </div>
              </div>
              <!-- <p class="mb-0">size: {{ image == null ? '' : image.size/1024 }}KB</p> -->
            </div>
          </div>
          <div style="padding: 20px 0 20px 0" class="bg-confirm-action">
            <div>
              <div
                style="
                  font-family: 'Bai Jamjuree', sans-serif;
                  font-size: 16px;
                  padding: 0 0 20px 0;
                "
              >
                คุณต้องการยืนยันรายการเป็นสถานะ
                <span style="font-weight: bold">Delivering</span> ใช่หรือไม่ ?
              </div>
              <v-btn
                @click="shipping_btn('save')"
                rounded
                class="ok"
                style="margin-right: 45px"
                :loading="loadding_shippop_booking"
                :disabled="loadding_shippop_booking"
                >{{ loadding_shippop_booking ? 'Loading...' : 'ใช่' }}</v-btn
              >
              <v-btn rounded @click="shipping_btn('close')" class="clear"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="DialogDetail"
      max-width="800"
      :width="data.order_status == 'Accept' ? 900 : 800"
    >
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div
              style="
                padding: 20px 0 0 0;
                font-size: 20px;
                font-family: 'Bai Jamjuree', sans-serif;
                text-align: center;
              "
            >
              รายละเอียดพัสดุสินค้า
            </div>
            <div style="width: 97%">
              <div
                class=""
                style="font-family: 'Bai Jamjuree', sans-serif;
                  width: 100%;
                  padding: 20px 0 10px 0;
                  text-align: left;
                  margin-left: 16px;"
              >
                ที่อยู่ต้นทาง <span style="color: red">*</span>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; margin-left: 16px;
                    margin-right: 16px;">
                <v-select
                  no-data-text="ไม่พบข้อมูลที่อยู่ต้นทาง"
                  v-model="from_address_select"
                  :items="sortedShipmentList"
                  :item-text="formatFromAddress"
                  :item-value="item => item"
                  style="
                    font-family: 'Bai Jamjuree', sans-serif;
                    width: 100%;
                    max-width: 100%;
                    min-width: 180px;
                  "
                  solo
                  dense
                  v-bind:class="[Error.errorShipping]"
                />
                <div
                  v-if="!from_address_select"
                  style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 12px;"
                >
                  กรุณาเลือกที่อยู่ต้นทาง
                </div>
              </div>
            </div>
            <div style="width: 97%">
              <div
                class=""
                style="
                  font-family: 'Bai Jamjuree', sans-serif;
                  width: 100%;
                  padding: 20px 0 10px 0;
                  text-align: left;
                  margin-left: 16px;
                "
              >
                บริษัทขนส่ง <span style="color: red">*</span>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; margin-left: 16px;
                    margin-right: 16px;">
                <!-- <v-data-table no-data-text="My no data message"></v-data-table> -->
                <v-select
                :key="shippingSelectKey"  
                  no-data-text="ไม่พบข้อมูลบริษัทขนส่ง"
                  v-on:change="select_shipping()"
                  v-bind:class="[Error.errorShipping]"
                  style="
                    font-family: 'Bai Jamjuree', sans-serif;
                    width: 100%;
                    max-width: 100%;
                    min-width: 180px;
                    
                  "
                  solo
                  dense
                  v-model="shipping_select"
                  :items="dataShipping"
                  :item-text="item => item.shipping_name"
                  :item-value="item => item"
                />
                <div
                  v-if="shipping_select === ''"
                  style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 12px;"
                >
                  กรุณากรอกข้อมูลให้ครบ
                </div>
              </div>
            </div>
            <!-- เพิ่มฟอร์มกรอกข้อมูลกล่องพัสดุ -->

             <!-- น้ำหนัก(G) ความกว้าง(Cm) ยาว(Cm) สูง(Cm) จำนวนกล่อง -->
             <div style="margin:30px 10px 0 16px; padding-right: 30px; display: flex; flex-direction: column;">
              <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px; justify-content: center;">
                <div style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;">
                  น้ำหนัก(G)
                </div>
                <div style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;">
                  กว้าง(Cm)
                </div>
                <div style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;">
                  ยาว(Cm)
                </div>
                <div style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;">
                  สูง(Cm)
                </div>
                <div style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;">
                  จำนวนกล่อง
                </div>
              </div>
             </div>
            <v-form ref="parcelForm" v-model="parcelFormValid" v-if="!isSelfShipping || true">
              <div style="margin:16px; display: flex; flex-direction: column;  ">
                <div
                  v-for="(parcel, idx) in parcels"
                  :key="idx"
                  style="display: flex; gap: 10px; align-items: center; justify-content: center;"
                >
                  <div
                    class=""
                    style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; height: 10%; padding: 0px 0 0px 0; text-align: left;"
                  >
                    <!-- น้ำหนัก(G) -->
                    <v-text-field
                      v-model="parcel.weight"
                      type="number"
                      min="0"
                      dense
                      solo
                      class="parcel-field"
                      style="max-width: 90px; margin-top: 5px;"
                      :required="!isSelfShipping && !!shipping_select"
                      :disabled="isSelfShipping"
                      @keydown="blockSpecialChar"
                      :rules="parcelRules"
                    />
                    <div
                      v-if="shipping_select !== '' && !parcel.weight && !isSelfShipping"
                      style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 15px;"
                    >
                      กรุณากรอกน้ำหนัก
                    </div>
                  </div>
                  <div
                    class=""
                    style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;"
                  >
                    <!-- กว้าง(Cm) -->
                    <v-text-field
                      v-model="parcel.width"
                      type="number"
                      min="0"
                      dense
                      solo
                      class="parcel-field"
                      style="max-width: 90px; margin-top: 5px;"
                      :required="!isSelfShipping && !!shipping_select"
                      :disabled="isSelfShipping"
                      @keydown="blockSpecialChar"
                      :rules="parcelRules"
                    />
                    <div
                      v-if="shipping_select !== '' && !parcel.width  && !isSelfShipping"
                      style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 15px;"
                    >
                      กรุณากรอกความกว้าง
                    </div>
                  </div>
                  <div
                    class=""
                    style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;"
                  >
                    <!-- ยาว(Cm) -->
                    <v-text-field
                      v-model="parcel.length"
                      type="number"
                      min="0"
                      dense
                      solo
                      class="parcel-field"
                      style="max-width: 90px;"
                      :required="!isSelfShipping && !!shipping_select"
                      :disabled="isSelfShipping"
                      @keydown="blockSpecialChar"
                      :rules="parcelRules"
                    />
                    <div
                      v-if="shipping_select !== '' && !parcel.length && !isSelfShipping"
                      style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 15px;"
                    >
                      กรุณากรอกความยาว
                    </div>
                  </div>
                  <div
                    class=""
                    style="font-family: 'Bai Jamjuree', sans-serif; width: 67%; padding: 0px 0 0px 0; text-align: left;"
                  >
                    <!-- สูง(Cm) -->
                    <v-text-field
                      v-model="parcel.height"
                      type="number"
                      min="0"
                      dense
                      solo
                      class="parcel-field"
                      style="max-width: 90px;"
                      :required="!isSelfShipping && !!shipping_select"
                      :disabled="isSelfShipping"
                      @keydown="blockSpecialChar"
                      :rules="parcelRules"
                    />
                    <div
                      v-if="shipping_select !== '' && !parcel.height && !isSelfShipping"
                      style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 15px;"
                    >
                      กรุณากรอกความสูง
                    </div>
                  </div>
                  <div
                    class=""
                    style="font-family: 'Bai Jamjuree', sans-serif; width: 65%; padding: 0px 0 0px 0; text-align: left;"
                  >
                    <!-- จำนวนกล่อง -->
                    <v-text-field
                      v-model="parcel.qty"
                      type="number"
                      min="1"
                      dense
                      solo
                      class="parcel-field"
                      style="max-width: 100px;"
                      :required="!isSelfShipping && !!shipping_select"
                      :disabled="isSelfShipping"
                      @keydown="blockSpecialChar"
                      :rules="parcelRules"
                    />
                    <div
                      v-if="shipping_select !== '' && !parcel.qty"
                      style="color: #da0707; font-family: 'Bai Jamjuree', sans-serif; font-size: 13px; margin-top: 15px;"
                    >
                      กรุณากรอกจำนวนกล่อง
                    </div>
                  </div>
                  <v-btn
                    icon
                    small
                    color="silver"
                    @click="removeParcel(idx)"
                    :disabled="parcels.length === 1"
                    style="margin-top: 35px; min-width: 24px; width: 24px; height: 24px; "
                    :title="parcels.length === 1 ? 'เหลือ 1 กล่อง ไม่สามารถลบได้' : 'ลบแถวนี้'"
                  >
                    <v-icon style="display:flex; align-items:center; justify-content:center; line-height:20px; padding-bottom: 25px; padding-right: 30px; "  size="26">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- ปุ่มเพิ่มกล่อง ย้ายมาไว้ด้านล่าง พร้อมข้อความ "เพิ่มกล่อง" -->
              <div style="display:flex; justify-content:left; margin-left: 20px; margin-bottom: 8px;">
                <v-btn
                  color="#2979FF"
                  dark
                  rounded
                  @click="addParcel"
                  style="margin-top: 5px; border-radius: 50%; min-width: 24px; width: 24px; height: 24px; padding: 0; box-shadow: 0 2px 6px rgba(25, 118, 210, 0.15); border: 1.5px solid #1976d2; display: flex; align-items: center; justify-content: center;"
                >
                  <v-icon style="font-size:16px;">mdi-plus</v-icon>
                  
                </v-btn>
                <div style=" font-family: 'Bai Jamjuree', sans-serif; margin-top: 5px;  min-width: 24px; width: 72px; height: 24px; padding: 0; display: flex; align-items: center; justify-content: center; color: #1D4ED8;">
                  เพิ่มกล่อง
                </div>
              </div>
            </v-form>
            
          </div>
          <div style="padding: 20px 0 20px 0" class="bg-confirm-action">
            <div>
              <div
                style="
                  font-family: 'Bai Jamjuree', sans-serif;
                  font-size: 16px;
                  padding: 0 0 20px 0;
                "
              >
                คุณต้องการยืนยันรายการเป็นสถานะ
                <span style="font-weight: bold">Delivery</span> ใช่หรือไม่ ?
              </div>
              <v-btn @click="detail_btn_action('save')" rounded class="ok" style="margin-right: 45px" :loading="loadding_shippop_booking" :disabled="loadding_shippop_booking">{{ loadding_shippop_booking ? 'Loading...' : 'ใช่' }}</v-btn>
              <v-btn rounded @click="detail_btn_action('close')" class="clear">ไม่</v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'detail-dialog',
  props: {
    data: Object,
    dataShipping: Array,
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // สำหรับที่อยู่ต้นทางและบริษัทขนส่ง
      parcelRules: [
        v => (v !== null && v !== undefined && String(v).trim() !== '') || '*'
      ],
      shippingSelectKey: 0,
      bsLabelFiles: [],
      showBsLabelDialog: false,
      from_address_select: null,
      shipmentList: [],
      dup_dataShipping: this.dataShipping,
      shipping_select: null,
      shipping_number: '',
      show_count:'',
      dialogNoShipment: false,
      DialogShipping: false,
      DialogDetail: false,
      dialog_success2: false,         // แจ้งบันทึกสำเร็จ
      dialog_send_mail: false,        // แจ้งส่งอีเมล
      dialogInvoice: false,           // แนบไฟล์ invoice
      dialogBookingSuccess: false,    // แจ้ง booking สำเร็จ
      bookingSuccessMsg: '',          // ข้อความ booking สำเร็จ
      dialogBookingError: false,      // แจ้ง booking ไม่สำเร็จ
      bookingErrorMsg: '',            // ข้อความ booking error
      confirmChangeAddress: false,    // ยืนยันเปลี่ยนที่อยู่
      confirmResend: false,           // ยืนยันส่งอีเมลอีกครั้ง
      dialogError: false,             // แจ้ง error อื่นๆ
      errorMsg: '',                   // ข้อความ error อื่นๆ

      // ฟอร์มและ error
      confirmText: '',
      confirmDialog_print: false,
      confirmText_print: '',
      confirmBtn: '',
      confirmDialog: false,
      confirmPrint: false,
      file_error: false,
      loadding_shipping: false,
      loadding_shippop_booking: false,
      loadding_upload_image: false,
      invoiceFile: null,
      invoicePreview: null,
      invoiceError: '',

      // ข้อมูลกล่องพัสดุ
      parcels: [
        { weight: '', width: '', length: '', height: '', qty: 1 }
      ],
      parcelFormValid: false,

      // อื่นๆ
      windowSize: 1366,
      radio: 'customer',
      mapObj: [],
      page_first: 12,
      page_ohter: 19,
      Error: {
        errorShipping: '',
        errorShipping_txt: '',
        errorTracking_txt: '',
        errorImg_txt: '',
        errorImg: ''
      },
      monthsShort: [
        'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
        'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
      ],
      headColum: ['#', 'SKU', 'รายการสินค้า', 'จำนวน', 'หมายเหตุ'],
      preview: null,
      image: null,
      imageMap: {}, // เพิ่มให้เหมือน admin
    }
  },
  computed: {
     userId() {
      let userProfile = null;
      try {
        userProfile = JSON.parse(localStorage.getItem('user_profile'));
      } catch (e) {}
      return (
        (userProfile && (userProfile.user_id || userProfile.sup_user_id || userProfile.user_account)) ||
        this.data.user_id ||
        this.data.sup_user_id ||
        this.data.user_account ||
        ''
      );
    },
    showShipping() {
    // true เมื่อมีชื่อบริษัทขนส่ง และสถานะไม่ใช่ New หรือ Accept
      return !!(
        this.data &&
        this.data.shipping_name &&
        String(this.data.shipping_name).trim() !== '' &&
        this.data.order_status &&
        !['New', 'Accept'].includes(String(this.data.order_status))
      );
    },
    sortedShipmentList() {
      if (!this.data.user_id || !this.shipmentList.length) {
        return [];
      }

      return [...this.shipmentList].filter(item =>
         item.user_id == this.data.user_id
      );
    },
    
    imageUrl() {
      // ถ้ามีไฟล์ที่เพิ่งเลือก (File object)
      if (this.image instanceof File) {
        return URL.createObjectURL(this.image);
      }
      // ถ้ามีไฟล์ที่เคยอัปโหลดไว้ (string ชื่อไฟล์จาก backend)
      if (typeof this.data.inv_purchase_file === 'string' && this.data.inv_purchase_file) {
        return `/images/invoice-img/${this.data.inv_purchase_file}`;
      }
      return '';
    },
    isSelfShipping() {
      return this.shipping_select && this.shipping_select.shipping_channel === 'OWN_FLEET';
    },
    detect_device () {
      return Vue.localStorage.get('DETECTED_DEVICE')
    },

    dialog: {
      get () {
        return this.show
      },
      set (value) {
        this.close()
      }
    },
    renderBtn () {
      if (this.data.order_status == 'New') {
        return 'Accept'
      } else if (this.data.order_status == 'Accept') {
        return 'Delivery'
      } else if (this.data.order_status == 'Delivery') {
        return this.data.shipping_channel && this.data.shipping_channel === 'OWN_FLEET' ? 'Delivering' : ''
      } else if (this.data.order_status == 'Delivering') {
        return this.data.shipping_channel && this.data.shipping_channel != 'OWN_FLEET' ? '' : 'Complete'
      } else {
        return ''
      }
    }
  },
  watch: {
    data: {
    handler(val) {
      // อัปเดตไฟล์ invoice
      if (this.data && this.data.purchase_id) {
        this.image = this.imageMap[this.data.purchase_id] || null;
      } else {
        this.image = null;
      }
      if (this.data && this.data.order_status === 'Delivering') {
        const v = this.data.change_address;
        if (
          v === 1 ||
          v === true ||
          v === 'True' ||
          v === 'true' ||
          v === 'TRUE' ||
          v === '1'
        ) {
          this.radio = 'supply';
        } else {
          this.radio = 'customer';
        }
      }
      // Auto select radio ตาม change_address
      // if (
      //   val &&
      //     val === 1 ||
      //     val === true ||
      //     val === 'True' ||
      //     val === 'true' ||
      //     val === 'TRUE' ||
      //     val === '1'
      //   ) {
      //     this.radio = 'supply';
      //   } else {
      //     this.radio = 'customer';
      //   }
    },
    immediate: true
  },
  DialogDetail(val) {
      if (val) {
        this.resetDialogDetail && this.resetDialogDetail();
        // ถ้าเปิดในสถานะ Delivering ให้ตั้ง radio ตาม change_address ทันที
        if (this.data && this.data.order_status === 'Delivering') {
          const v = this.data.change_address;
          this.radio = (v === 1 || v === true || v === 'True' || v === 'true' || v === 'TRUE' || v === '1') ? 'supply' : 'customer';
        }
      }
    },
  show(val) {
    if (val && this.data && this.data.purchase_id) {
      this.image = this.imageMap[this.data.purchase_id] || null;
    }
  }
  },
  mounted() {
    this.fetchShipmentList();
  },
  methods: {
    formatFromAddress(item) {
      if (!item) return '-';
      const parts = [
        item.from_address,
        item.from_subdistrict || item.from_district || '',
        item.from_district || '',
        item.from_state || '',
        item.from_province || '',
        item.from_postcode || ''
      ].filter(Boolean);
      return parts.length ? parts.join(' | ') : (item.from_name || '-');
    },
    goToUserProfile() {
      this.dialogNoShipment = false;
      this.$router.push('/userprofile');
    },
    
  fetchShipmentList() {
      const data = {
        event: 'get_all',
        user_id: this.data.user_id || this.userId
      };
      this.$store
        .dispatch('fetchShipmentList', data)
        .then(res => {
          // ไม่ต้องกรอง user_id เอาทุก address ที่ backend ส่งมา
          this.shipmentList = Array.isArray(res) ? res : [];
          console.log('fetchShipmentList response:', this.shipmentList);
          // รับรายการจาก backend
          const list = Array.isArray(res) ? res : [];
          this.shipmentList = list;
          console.log('fetchShipmentList response:', this.shipmentList);

          // ถ้ายังไม่มีการเลือก from_address_select ให้หา default (is_default == 1) ของ user นี้
          try {
            const userId = this.data && this.data.user_id ? this.data.user_id : this.userId;
            if (!this.from_address_select && userId) {
              const userAddresses = list.filter(item => String(item.user_id) === String(userId));
              const defaultAddr = userAddresses.find(i => Number(i.is_default) === 1) || userAddresses[0] || null;
              if (defaultAddr) {                this.from_address_select = defaultAddr;
              }
            }
          } catch (e) {
            console.warn('fetchShipmentList: cannot auto-select default address', e);
          }
        });
    },
    closeInvoiceDialog() {
      this.dialogInvoice = false;
      this.invoiceFile = null;
      this.invoicePreview = null;
      this.invoiceError = '';
    },
    closedialoglabel() {
      this.showBsLabelDialog = false;
      this.bsLabelFiles = [];
    },
    onInvoiceFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const validTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'application/zip',
        'application/x-zip-compressed'
      ];
      const ext = file.name.split('.').pop().toLowerCase();

      if (
        !validTypes.includes(file.type) &&
        !['pdf', 'jpg', 'jpeg', 'png', 'zip'].includes(ext)
      ) {
        this.invoiceError = 'รองรับเฉพาะ PDF, JPG, JPEG, PNG, ZIP';
        this.invoiceFile = null;
        this.invoicePreview = null;
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.invoiceError = 'ขนาดไฟล์ต้องไม่เกิน 2MB';
        this.invoiceFile = null;
        this.invoicePreview = null;
        return;
      }

      this.invoiceError = '';
      this.invoiceFile = file;

      if (this.isImageFile(file)) {
        const reader = new FileReader();
        reader.onload = e => {
          this.invoicePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      } else if (this.isPdfFile(file)) {
        this.invoicePreview = URL.createObjectURL(file); // สำหรับ PDF
      } else {
        this.invoicePreview = null; // ZIP ไม่สามารถ preview เนื้อหา
      }
    },
    isImageFile(file) {
      return file && file.type.startsWith('image/');
    },
    isPdfFile(file) {
      return file && file.type === 'application/pdf';
    },

    isZipFile(file) {
      return file && (file.type === 'application/zip' || file.type === 'application/x-zip-compressed');
    },
    
    closeInvoiceDialog() {
      if (this.invoicePreview && this.isPdfFile(this.invoiceFile)) {
        URL.revokeObjectURL(this.invoicePreview);
      }
      this.dialogInvoice = false;
      this.invoiceFile = null;
      this.invoicePreview = null;
      this.invoiceError = '';
    },
    isImageFile(file) {
      return file && (file.type === 'image/jpeg' || file.type === 'image/png');
    },
    async saveInvoiceFile() {
      if (this.data && this.data.purchase_id && this.invoiceFile) {
        const formData = new FormData();
        formData.append('purchase_id', this.data.purchase_id);
        formData.append('image', this.invoiceFile);

        // ส่งไฟล์ไป backend
        const res = await this.$store.dispatch('uploadInvoiceFile', formData);

        // ถ้า backend ส่งชื่อไฟล์กลับมา อัปเดตใน frontend
        if (res.data && res.data.success && res.data.success.filename) {
          this.image = this.invoiceFile;
          this.$set(this.imageMap, this.data.purchase_id, this.invoiceFile);
          this.data.inv_purchase_file = res.data.success.filename;

          // โหลดข้อมูลใหม่
          const perc_id = [this.data.purchase_id];
          const detailRes = await this.$store.dispatch('getOrderDetail', JSON.stringify(perc_id));
          if (detailRes && detailRes.success && detailRes.success.data && detailRes.success.data[0]) {
            Object.assign(this.data, detailRes.success.data[0]);
          }
        }
      }
      this.dialogInvoice = false;
      this.invoicePreview = null;
      this.invoiceFile = null;
      this.invoiceError = '';
    },
    async saveInvoiceFile() {
      if (!this.invoiceFile) {
        this.invoiceError = 'กรุณาเลือกไฟล์';
        return;
      }
      if (this.invoiceFile.size > 2 * 1024 * 1024) {
        this.invoiceError = 'ขนาดไฟล์ต้องไม่เกิน 2MB';
        return;
      }

      const uploadData = {
        image: this.invoiceFile,
        detail: this.data.purchase_id
      };

      try {
        this.loadding_upload_image = true;
        // อัปโหลดไฟล์ไป backend
        const result = await this.$store.dispatch('Up', uploadData);
        if (result.data && result.data.success && result.data.success.filename) {
          this.data.inv_purchase_file = result.data.success.filename;
        }

        // ดึงข้อมูล order detail ใหม่
        const perc_id = [this.data.purchase_id];
        const detailRes = await this.$store.dispatch('getOrderDetail', JSON.stringify(perc_id));
        if (detailRes && detailRes.success && detailRes.success.data && detailRes.success.data[0]) {
          Object.assign(this.data, detailRes.success.data[0]);
        }

        // reset state
        this.image = null;
        this.invoiceFile = null;
        this.invoicePreview = null;
        this.invoiceError = '';
        this.dialogInvoice = false;
        this.loadding_upload_image = false;
      } catch (e) {
        this.loadding_upload_image = false;
        this.invoiceError = 'อัปโหลดไฟล์ไม่สำเร็จ';
      }
    },
    downloadInvoiceFile() {
      if (this.data && this.data.inv_purchase_file) {
        this.$store.dispatch('downloadInvoiceFile', this.data.inv_purchase_file);
      }
    },
    mainAction() {
      // ถ้าสถานะ Accept และ shipmentList ไม่มีข้อมูล
      if (this.data.order_status === 'Accept' && (!this.shipmentList || this.shipmentList.length === 0)) {
        this.dialogNoShipment= true;
        return;
      }
      if (this.data.order_status === 'Accept') {
        this.resetDialogDetail && this.resetDialogDetail();
        if (this.$refs.parcelForm && this.$refs.parcelForm.resetValidation) {
          this.$refs.parcelForm.resetValidation();
        }
        this.DialogDetail = true;
      } else {
        if (this.data.order_status === 'Delivering') {
          const v = this.data.change_address;
          if (
            v === 1 ||
            v === true ||
            v === 'True' ||
            v === 'true' ||
            v === 'TRUE' ||
            v === '1'
          ) {
            this.radio = 'supply';
          } else {
            this.radio = 'customer';
          }
        }
        this.accept();
      }
      
    },
    blockSpecialChar(e) {
      // ไม่ให้กรอก ., e, +, -, และอักษรพิเศษอื่นๆ
      if (
        ['.', 'e', 'E', '+', '-', ',', '/', '\\', '*', '%', '$', '#', '@', '!', '^', '&', '(', ')', '[', ']', '{', '}', '?', ':', ';', '\'', '"', '<', '>', '|', '='].includes(e.key)
      ) {
        e.preventDefault();
      }
    },
    previewImage: function (event) {
      var input = event.target
      if (input.files) {
        var reader = new FileReader()
        reader.onload = e => {
          this.preview = e.target.result
        }
        this.image = input.files[0]
        reader.readAsDataURL(input.files[0])
        // this.typeFile = input.files[0].type
      }
    },

    reset: function () {
      let id = document.getElementById('imageUpload')
      if (id !== null) {
        document.getElementById('imageUpload').value = ''
      }
      this.file_error = false
      this.image = null
      this.preview = null
    },

    up () {
      this.$store
        .dispatch('Up', this.image)
        .then(res => {
          //
        })
        .catch(error => {})
    },

    clear_shipping_number () {
      this.shipping_number = '';
      this.Error.errorTracking_txt = '';
    },

    clearTrackingNumberError () {
      this.Error.errorTracking_txt = '';
    },
    clear_image () {
      this.reset()
    },
    select_shipping () {
      this.Error.errorShipping = ''
      this.Error.errorShipping_txt = ''
    },
    shipping_btn(param) {
      if (param == 'save') {
        var check1 = false;

        this.Error.errorTracking_txt = '';
        const trackingOk = String(this.shipping_number || '').trim().length > 0;
        if (!trackingOk) {
          this.Error.errorTracking_txt = this.$t('txt-wrong25');
        }

        // เช็คไฟล์ invoice
        if (this.image) {
          if (this.image.size / 1024 > 2000) {
            check1 = false;
            this.Error.errorImg = 'error-case';
            this.Error.errorImg_txt = this.$t('txt-wrong21');
            this.file_error = true;
          } else {
            check1 = true;
            this.file_error = false;
          }
        } else {
          this.Error.errorImg = 'error-case';
          this.Error.errorImg_txt = this.$t('txt-wrong21');
          check1 = false;
          this.file_error = true;
        }

        if (check1 && trackingOk) {
          this.submit();
        }
      } else {
        this.shipping_select = '';
        this.shipping_number = '';
        this.Error.errorTracking_txt = '';
        this.DialogShipping = false;
      }
    },
    currency (qty) {
      return window.currency(qty)
    },
    ratio (val) {
      this.radio = val
    },
    
    renderBorder (index) {
      if (index == 0) {
        return '8px 8px 0px 0px'
      } else if (index == this.data.items.length - 1) {
        return '0px 0px 8px 8px'
      } else {
        return '0px'
      }
    },
    formatDate (val) {
      if (val !== null) {
        let today = new Date(val)
        const year = today.getFullYear()
        const fullYear = year
        const days = today.getDate()
        const monthName = this.monthsShort[today.getMonth()]

        return days + ' ' + monthName + ' ' + fullYear
      } else {
        return val
      }
    },
    close () {
      this.$emit('close', {})
    },
    async submit_print(param) {
      try {
        const Profile = JSON.parse(localStorage.getItem('user_profile'));
        const res = await this.$store.dispatch('getLabelFile', { purchase_id: param.purchase_id });

        // กรณี BS ส่ง filename เป็น array (หลายกล่อง)
        if (
          res.data &&
          res.data.success &&
          res.data.data &&
          res.data.data.filename
        ) {
          const filenames = Array.isArray(res.data.data.filename)
            ? res.data.data.filename
            : [res.data.data.filename];

          for (const fname of filenames) {
            const url_file = await this.$store.dispatch('getUrlFile', { url_file: fname });
            window.open(url_file, '_blank');
          }
        } else {
          // fallback ไปปริ้นแบบเดิม
          this.mapObj = [];
          this.fromData(this.data); 
          Vue.localStorage.set('PRINT_LABEL', JSON.stringify(this.mapObj));
          setTimeout(() => {
            window.open('/#/PrintLabel');
          }, 1000);
        }
      } catch (e) {
        // fallback ไปปริ้นแบบเดิม
        this.mapObj = [];
        this.fromData(this.data);
        Vue.localStorage.set('PRINT_LABEL', JSON.stringify(this.mapObj));
        setTimeout(() => {
          window.open('/#/PrintLabel');
        }, 1000);
      }
      this.confirmDialog_print = false;
    },
    accept () {
      this.confirmPrint = false
      if (this.data.order_status == 'New') {
        this.confirmText = 'คุณต้องการยืนยันรายการเป็นสถานะ Accept ใช่หรือไม่ ?'
      } else if (this.data.order_status == 'Accept') {
        this.confirmText =
          'คุณต้องการยืนยันรายการเป็นสถานะ Delivery ใช่หรือไม่ ?'
      } else if (this.data.order_status == 'Delivery') {
        this.confirmText =
          'คุณต้องการยืนยันรายการเป็นสถานะ Delivering ใช่หรือไม่ ?'
      } else if (this.data.order_status == 'Delivering') {
        // this.radio = 'customer'
        this.confirmText = 'การจัดส่งพัสดุสำเร็จ'
      } else {
        this.confirmText = ''
      }

      this.confirmBtn = 'ใช่'
      if (this.data.order_status != 'Delivery') {
        this.confirmDialog = true
      } else {
        setTimeout(() => {
          let data = {
            event: 'dropdown',
            shipping_id: '',
            shipping_code: '',
            shipping_name: '',
            shipping_track_link: '',
            is_active: ''
          }
          this.$store
            .dispatch('shippingMaster', data)
            .then(res => {
              this.dataShipping = res
            })
            .catch(error => {
              if (error.response.status == 401) {
                sessionStorage.removeItem('user_profile')
                sessionStorage.removeItem('token_seesion')
                this.tokenExpired = true
                console.log('Error 401')
              }
            })
        }, 1000)
        this.Error.errorTracking_txt = '';
        this.DialogShipping = true
        // this.resetDialogDetail()
      }
    },
    async submit() {
      let process = '';
      let orderRemarks = '';
      console.log('submit process:', this.data.order_status);
      if (this.data.order_status.toLowerCase() == 'new') {
        process = 'Accept';
      } else if (this.data.order_status.toLowerCase() == 'accept') {
        process = 'Delivery';
            } else if (this.data.order_status.toLowerCase() == 'delivery' && !this.confirmPrint) {
        process = 'Delivering';
      } else if (this.data.order_status.toLowerCase() == 'delivery' && this.confirmPrint) {
        process = 'print';
      } else if (this.data.order_status.toLowerCase() == 'delivering' && this.radio !== null) {
        process = 'Complete';
      } else {
        process = '';
      }
      if (process === 'Accept') {
        let acceptObj = {
          purchase_id: this.data.purchase_id,
          order_status: process,
          order_remarks: orderRemarks || '',
          shipping_code: '',
          tracking_code: '',
        };



        Object.keys(acceptObj).forEach(key => {
          if (acceptObj[key] === undefined || acceptObj[key] === null) acceptObj[key] = '';
        });

        try {
          const res = await this.$store.dispatch('sendOrderStatus', acceptObj);
          // เช็ค res.success ด้วย
          if (res && res.success) {
            // ดึงข้อมูลใหม่
            const detailRes = await this.$store.dispatch('getOrderDetail', JSON.stringify([this.data.purchase_id]));
            if (detailRes && detailRes.success && detailRes.success.data && detailRes.success.data[0]) {
              Object.assign(this.data, detailRes.success.data[0]);
            }
            this.confirmDialog = false;
            this.DialogDetail = false;
            try {
              this.resetDialogDetail && this.resetDialogDetail();
              this.reset && this.reset();
            }
            catch (e) {
              // ignore
            } 
          }
        } catch (e) {
          // handle error
        }
        return;
      }
      console.log('process after check:', process);
      if (process !== '') {
        console.log('สถานะก่อนส่ง Accept:', this.data.order_status);
        let perc_id = [this.data.purchase_id];
        const res = await this.$store.dispatch('getOrderDetail', JSON.stringify(perc_id));
        let backendStatus = this.data.order_status;
        if (res && res.success && res.success.data && res.success.data[0]) {
          backendStatus = res.success.data[0].order_status;
          this.data.order_status = backendStatus; 
        }
        
        if (process === 'Delivery') {
          
          if (backendStatus.toLowerCase() === 'new') {
            let acceptObj = {
              purchase_id: this.data.purchase_id,
              order_status: 'Accept'
            };
            try {
              await this.$store.dispatch('sendOrderStatus', acceptObj);
            } catch (e) {
              return;
            }

            // 2. getOrderDetail เพื่อรีเฟรชข้อมูล
            const resDelivery = await this.$store.dispatch('getOrderDetail', JSON.stringify([this.data.purchase_id]));
            if (resDelivery && resDelivery.success && resDelivery.success.data && resDelivery.success.data[0]) {
              Object.assign(this.data, resDelivery.success.data[0]);
            }
          }

          if (
            this.shipping_select &&
            this.shipping_select.shipping_channel === 'OWN_FLEET'
          ) {
            let obj = {
              purchase_id: this.data.purchase_id,
              order_status: process,
              shipping_code: this.shipping_select.shipping_code,
              tracking_code: this.shipping_number,
              shipping_channel: this.shipping_select.shipping_channel || '',
              order_remarks: this.data.order_remarks || '',
              order_delivery_date: this.data.order_delivery_date || '',
              order_success_date: this.data.order_success_date || '',
              shipping_track_link: this.shipping_select.shipping_track_link || '',
              image: this.image || ''
            };

            Object.keys(obj).forEach(key => {
              if (obj[key] === undefined || obj[key] === null) {
                obj[key] = '';
              }
            });

            try {
              this.loadding_shippop_booking = true;
              await this.$store.dispatch('sendOrderStatus', obj);
              const resBooking = await this.$store.dispatch('getOrderDetail', JSON.stringify([this.data.purchase_id]));
              if (resBooking && resBooking.success && resBooking.success.data && resBooking.success.data[0]) {
                Object.assign(this.data, resBooking.success.data[0]);
                // อัปเดตเลขพัสดุที่กรอกไว้ทันที
                this.data.tracking_code = this.shipping_number;
                this.data.shipping_name = this.shipping_select.shipping_name;
                this.data.order_status = process;
                this.$forceUpdate();
              }
              this.DialogShipping = false;
              this.confirmDialog = false;
            } catch (e) {
              // handle error
            } finally {
              this.loadding_shippop_booking = false;
            }
            return;
          }
          // === กรณี BS Express ===
          if (this.shipping_select && this.shipping_select.shipping_name === 'Bs Express') {
            const pad2 = n => n.toString().padStart(2, '0');
            const formatOrderDate = (date) => {
              if (!date) return '';
              const d = new Date(date);
              return (
                d.getFullYear() +
                '-' +
                pad2(d.getMonth() + 1) +
                '-' +
                pad2(d.getDate()) +
                'T' +
                pad2(d.getHours()) +
                ':' +
                pad2(d.getMinutes()) +
                ':' +
                pad2(d.getSeconds())
              );
            };
            // const firstParcel = this.parcels[0] || { weight: 0, width: 0, length: 0, height: 0, qty: 1 };
            // const bsQty = this.parcels.reduce((sum, p) => sum + Number(p.qty || 0), 0);
            // const bsPayload = {
            //   purchase_id: this.data.purchase_id || '',
            //   Head: {
            //     ORDID: '',
            //     CompanyID: 'DC0002',
            //     OrderDate: formatOrderDate(this.data.order_date)
            //   },
            //   Line: [
            //     {
            //       OrdUnqID: '',
            //       OrderQty: 1,
            //       Unit: 'กล่อง',
            //       WUnit: 'KG',
            //       ItemDesc: (this.data.items && this.data.items[0] && this.data.items[0].product_name) ? this.data.items[0].product_name : '-',
            //       Width: Number(firstParcel.width) || 0,
            //       Length: Number(firstParcel.length) || 0,
            //       Height: Number(firstParcel.height) || 0,
            //       Weight: Number(firstParcel.weight) || 0,
            //       Dimension:
            //         (Number(firstParcel.width) || 0) +
            //         (Number(firstParcel.length) || 0) +
            //         (Number(firstParcel.height) || 0),
            //       Price: (this.data.items && this.data.items[0] && this.data.items[0].price) ? this.data.items[0].price : 0,
            //       CODAmt: 0
            //     }
            //   ],
            //   Address: [
            //     {
            //       AddrType: 'SENDER',
            //       Name1: (this.from_address_select && this.from_address_select.from_name) ? this.from_address_select.from_name : (this.data.sup_name || ''),
            //       Name2: (this.from_address_select && this.from_address_select.from_surname) ? this.from_address_select.from_surname : (this.data.sup_surname || '-'),
            //       AddrNo: (this.from_address_select && this.from_address_select.from_address) ? this.from_address_select.from_address : (this.data.sup_address || ''),
            //       AddrMoo: (this.from_address_select && this.from_address_select.from_moo) ? this.from_address_select.from_moo : '',
            //       AddrTumbon: String(
            //         (this.from_address_select && this.from_address_select.from_sub_district)
            //           ? this.from_address_select.from_sub_district
            //           : (this.data.sup_subdistrict || '-')
            //       ),
            //       AddrAmphoe: String((this.from_address_select && this.from_address_select.from_district) ? this.from_address_select.from_district : (this.data.sup_district || '')),
            //       AddrProvince: String((this.from_address_select && this.from_address_select.from_province) ? this.from_address_select.from_province : (this.data.sup_province || '')),
            //       AddrPostCode: String((this.from_address_select && this.from_address_select.from_postcode) ? this.from_address_select.from_postcode : (this.data.sup_postal || '')),
            //       TaxID: (this.from_address_select && this.from_address_select.from_taxid) ? this.from_address_select.from_taxid : '',
            //       Tel: (this.from_address_select && this.from_address_select.from_tel) ? this.from_address_select.from_tel : (this.data.sup_phone || ''),
            //       ContactPerson: (this.from_address_select && this.from_address_select.from_contact_person) ? this.from_address_select.from_contact_person : '',
            //       GeoLocation: (this.from_address_select && this.from_address_select.from_geo_location) ? this.from_address_select.from_geo_location : ''
            //     },
            //     {
            //       AddrType: 'RECEIVER',
            //       Name1: this.data.cus_name || '',
            //       Name2: this.data.cus_surname || '-',
            //       AddrNo: this.data.cus_address || '',
            //       AddrMoo: this.data.cus_moo || '',
            //       AddrTumbon: String(this.data.cus_subdistrict || '-'),
            //       AddrAmphoe: String(this.data.cus_district || ''),
            //       AddrProvince: String(this.data.cus_province || ''),
            //       AddrPostCode: String(this.data.cus_postal || ''),
            //       TaxID: this.data.cus_taxid || '',
            //       Tel: this.data.cus_phone || '',
            //       ContactPerson: this.data.cus_contact_person || '',
            //       GeoLocation: this.data.cus_geo_location || ''
            //     }
            //   ],
            //   courier_code: 'BS_EXPRESS',
            //   BsQty: bsQty,
            // };
            const expanded = this.expandParcels(this.parcels);
            const bsQty = expanded.length;
            const Line = expanded.map(p => ({
              OrdUnqID: '',
              OrderQty: 1,
              Unit: 'กล่อง',
              WUnit: 'KG',
              ItemDesc: (this.data.items && this.data.items[0] && this.data.items[0].product_name) ? this.data.items[0].product_name : '-',
              Width: Number(p.width) || 0,
              Length: Number(p.length) || 0,
              Height: Number(p.height) || 0,
              Weight: Number(p.weight) || 0,
              Dimension: (Number(p.width) || 0) + (Number(p.length) || 0) + (Number(p.height) || 0),
              Price: (this.data.items && this.data.items[0] && this.data.items[0].price) ? this.data.items[0].price : 0,
              CODAmt: 0
            }));

            const bsPayload = {
              purchase_id: this.data.purchase_id || '',
              Head: {
                ORDID: '',
                CompanyID: 'DC0002',
                OrderDate: formatOrderDate(this.data.order_date)
              },
              Line,
              Address: [
                {
                  AddrType: 'SENDER',
                  Name1: (this.from_address_select && this.from_address_select.from_name) ? this.from_address_select.from_name : (this.data.sup_name || ''),
                  Name2: (this.from_address_select && this.from_address_select.from_surname) ? this.from_address_select.from_surname : (this.data.sup_surname || '-'),
                  AddrNo: (this.from_address_select && this.from_address_select.from_address) ? this.from_address_select.from_address : (this.data.sup_address || ''),
                  AddrMoo: (this.from_address_select && this.from_address_select.from_moo) ? this.from_address_select.from_moo : '',
                  AddrTumbon: String(
                    (this.from_address_select && this.from_address_select.from_sub_district)
                      ? this.from_address_select.from_sub_district
                      : (this.data.sup_subdistrict || '-')
                  ),
                  AddrAmphoe: String((this.from_address_select && this.from_address_select.from_district) ? this.from_address_select.from_district : (this.data.sup_district || '')),
                  AddrProvince: String((this.from_address_select && this.from_address_select.from_province) ? this.from_address_select.from_province : (this.data.sup_province || '')),
                  AddrPostCode: String((this.from_address_select && this.from_address_select.from_postcode) ? this.from_address_select.from_postcode : (this.data.sup_postal || '')),
                  TaxID: (this.from_address_select && this.from_address_select.from_taxid) ? this.from_address_select.from_taxid : '',
                  Tel: (this.from_address_select && this.from_address_select.from_tel) ? this.from_address_select.from_tel : (this.data.sup_phone || ''),
                  ContactPerson: (this.from_address_select && this.from_address_select.from_contact_person) ? this.from_address_select.from_contact_person : '',
                  GeoLocation: (this.from_address_select && this.from_address_select.from_geo_location) ? this.from_address_select.from_geo_location : ''
                },
                {
                  AddrType: 'RECEIVER',
                  Name1: this.data.cus_name || '',
                  Name2: this.data.cus_surname || '-',
                  AddrNo: this.data.cus_address || '',
                  AddrMoo: this.data.cus_moo || '',
                  AddrTumbon: String(this.data.cus_subdistrict || '-'),
                  AddrAmphoe: String(this.data.cus_district || ''),
                  AddrProvince: String(this.data.cus_province || ''),
                  AddrPostCode: String(this.data.cus_postal || ''),
                  TaxID: this.data.cus_taxid || '',
                  Tel: this.data.cus_phone || '',
                  ContactPerson: this.data.cus_contact_person || '',
                  GeoLocation: this.data.cus_geo_location || ''
                }
              ],
              courier_code: 'BS_EXPRESS',
              BsQty: bsQty,
            };

            try {
              const Profile = JSON.parse(localStorage.getItem('user_profile'));
              const res = await this.$store.dispatch('bsExpressBooking', bsPayload);
              // getOrderDetail หลัง booking สำเร็จ
              if (res.status === 200 && res.data && res.data.result === true) {
                const resBooking = await this.$store.dispatch('getOrderDetail', JSON.stringify([this.data.purchase_id]));
                if (resBooking && resBooking.success && resBooking.success.data && resBooking.success.data[0]) {
                  Object.assign(this.data, resBooking.success.data[0]);
                }
                if (res.data.data && res.data.data.tracking_code) {
                  this.data.tracking_code = res.data.data.tracking_code;
                  this.data.shipping_name = 'BS_EXPRESS';
                }
                this.data.order_status = 'Delivery';
                this.dialogBookingSuccess = true;
                this.bookingSuccessMsg = 'Booking BS Express สำเร็จ';
                return;
              } else {
                // booking ไม่สำเร็จ
                let msg = (res.data && res.data.message) || 'ไม่สามารถ booking ได้ กรุณาตรวจสอบข้อมูลอีกครั้ง';
                this.bookingErrorMsg = msg;
                this.dialogBookingError = true;
                return;
              }
            } catch (error) {
              this.bookingErrorMsg = (error.response && error.response.data && error.response.data.message)
                ? error.response.data.message
                : 'ไม่สามารถ booking ได้ กรุณาตรวจสอบข้อมูลอีกครั้ง';
              this.dialogBookingError = true;
              return;
            }
          } else {
            // === ขนส่งอื่น (Shippop) ===
            const expandedParcels = this.expandParcels(this.parcels);
            const payload = {
              data: this.generateOrderArray(),
              purchase_id: this.data.purchase_id
            };
 
            try {
              console.log('Setting loadding_shippop_booking to true');
              this.loadding_shippop_booking = true;
              this.$forceUpdate(); // Force Vue to update the DOM

              const Profile = JSON.parse(localStorage.getItem('user_profile'));
              const res = await this.$store.dispatch('shippopBooking', payload);
              console.log('Shippop booking result:', res);

              // อัปเดต tracking code ถ้ามี
              if (res.data && res.data.data && res.data.data.confirm_order && res.data.data.confirm_order.result && res.data.data.confirm_order.result[0]) {
                const result = res.data.data.confirm_order.result[0];
                this.data.tracking_code = result.tracking_code || '';
                this.data.shipping_name = result.courier_code || '';
                this.data.order_status = 'Delivery';
              }

              // ถ้า booking สำเร็จ
              if (res.status === 200 && res.data && res.data.result === true) {
                const resBooking = await this.$store.dispatch('getOrderDetail', JSON.stringify([this.data.purchase_id]));
                if (resBooking && resBooking.success && resBooking.success.data && resBooking.success.data[0]) {
                  Object.assign(this.data, resBooking.success.data[0]);
                }
                
                this.loadding_shippop_booking = false;
                this.dialogBookingSuccess = true;
                this.bookingSuccessMsg = 'Booking สำเร็จ';
                return;
              } else {
                // ถ้า booking ไม่สำเร็จ
                let msg = (res.data && res.data.message) || 'เกิดข้อผิดพลาด';
                // กรณี booking ซ้ำ
                if (msg.includes('already in table booking_courier')) {
                  msg = 'เลขออเดอร์นี้ถูก booking ขนส่งไปแล้ว กรุณาตรวจสอบสถานะหรือพิมพ์ใบปะหน้า';
                }
                console.log('Shippop booking failed - Setting loadding_shippop_booking to false');
                this.loadding_shippop_booking = false;
                this.bookingErrorMsg = msg;
                this.dialogBookingError = true;
                return;
              }
            } catch (error) {
              console.log('Shippop booking error - Setting loadding_shippop_booking to false:', error);
              this.loadding_shippop_booking = false;
              this.bookingErrorMsg = (error.response && error.response.data && error.response.data.message)
                ? error.response.data.message
                : 'เกิดข้อผิดพลาดในการส่งข้อมูล';
              this.dialogBookingError = true;
              return;
            }
          }
        }

        if (process == 'Delivering') {
          this.loadding_shipping = true;
          let detail_remark = '';
          if (this.radio === 'customer') {
            detail_remark = 'พัสดุการนำจ่ายถึงลูกค้า';
          } else if (this.radio === 'supply') {
            detail_remark = 'พัสดุส่งกลับผู้ขาย';
          }

          let shipping_select = '';
          if (this.shipping_select == '') {
            shipping_select = {
              shipping_track_link: this.data.shipping_track_link,
              shipping_code: this.data.shipping_code,
              tracking_code: this.data.tracking_code,
              shipping_channel: this.data.shipping_channel || ''
            };
          } else {
            shipping_select = {
              shipping_track_link: this.shipping_select.shipping_track_link || '',
              shipping_code: this.shipping_select.shipping_code || '',
              tracking_code: this.shipping_number,
              shipping_channel: this.shipping_select.shipping_channel || ''
            };
          }

          let obj = {
            purchase_id: this.data.purchase_id,
            order_remarks: detail_remark,
            order_status: process,
            order_delivery_date: this.data.order_delivery_date,
            order_success_date: this.data.order_success_date,
            shipping_code: shipping_select.shipping_code,
            tracking_code: shipping_select.tracking_code,
            shipping_track_link: shipping_select.shipping_track_link,
            shipping_channel: shipping_select.shipping_channel,
            image: this.image
          };
          console.log('radio process Delivering', this.radio, 'order_remarks', detail_remark);
          this.$store
            .dispatch('sendOrderStatus', obj)
            .then(res => {
              // ถ้ามีไฟล์ image ให้ upload ก่อน
              if (this.image != null) {
                const uploadData = {
                  image: this.image,
                  detail: obj.purchase_id
                };
                return this.$store.dispatch('Up', uploadData);
              }
              return Promise.resolve();
            })
            .then(() => {
              // หลัง upload-image เสร็จ (หรือถ้าไม่มีไฟล์) ค่อย getOrderDetail
              let perc_id = [obj.purchase_id];
              return this.$store.dispatch('getOrderDetail', JSON.stringify(perc_id));
            })
            .then(res => {
              // อัปเดตข้อมูลใน data
              if (res && res.success && res.success.data && res.success.data[0]) {
                this.data.order_delivery_date = res.success.data[0].order_delivery_date;
                this.data.order_success_date = res.success.data[0].order_success_date;
                this.data.order_remarks = res.success.data[0].order_remarks;
                this.data.inv_purchase_file = res.success.data[0].inv_purchase_file;
                this.data.order_status = res.success.data[0].order_status;
                this.data.tracking_code = res.success.data[0].tracking_code;
              }
              this.loadding_shipping = false;
              this.DialogShipping = false;
              this.reset();
            })
            .catch(error => {
              this.loadding_shipping = false;
              if (error.response && error.response.status == 401) {
                sessionStorage.removeItem('user_profile');
                sessionStorage.removeItem('token_seesion');
                this.tokenExpired = true;
                console.log('Error 401');
              }
              if (error.response && error.response.status == 400) {
                this.file_error = true;
                this.Error.errorImg = 'error-case';
                this.Error.errorImg_txt = this.$t('txt-wrong24');
              }
            });
        } else {
          let shipping_select = '';
          if (this.shipping_select == '') {
            shipping_select = {
              shipping_track_link: this.data.shipping_track_link,
              shipping_code: this.data.shipping_code,
              tracking_code: this.data.tracking_code,
              shipping_channel: this.data.shipping_channel
            };
          } else {
            shipping_select = {
              shipping_track_link: this.shipping_select.shipping_track_link || '',
              shipping_code: this.shipping_select.shipping_code || '',
              tracking_code: this.shipping_number,
              shipping_channel: this.shipping_select.shipping_channel || ''
            };
          }

          let obj = {
            event: process,
            detail: this.radio,
            shipping_code: shipping_select.shipping_code,
            tracking_code: shipping_select.tracking_code,
            shipping_track_link: shipping_select.shipping_track_link,
            shipping_channel: shipping_select.shipping_channel,
            image: this.image
          };

          this.DialogShipping = false;
          this.$emit('submit', obj);
          this.shipping_select = '';
          this.shipping_number = '';
          this.confirmDialog = false;
        }
        if (process === 'Complete') {
          
          // เช็ค change_address เพื่อกำหนด order_remarks
          let orderRemarks = '';
          if (this.radio === 'supply') {
            orderRemarks = 'พัสดุส่งกลับถึงผู้ขาย';
          } else {
            orderRemarks = 'พัสดุการนำจ่ายถึงลูกค้า';
          }

          let obj = {
            purchase_id: this.data.purchase_id,
            order_status: process,
            order_remarks: orderRemarks,
            shipping_code: this.shipping_select.shipping_code,
            tracking_code: this.shipping_number,
            shipping_channel: this.shipping_select.shipping_channel || '',
            order_delivery_date: this.data.order_delivery_date || '',
            order_success_date: this.data.order_success_date || '',
            shipping_track_link: this.shipping_select.shipping_track_link || '',
            image: this.image || ''
          };

          Object.keys(obj).forEach(key => {
            if (obj[key] === undefined || obj[key] === null) {
              obj[key] = '';
            }
          });

          try {
            const res = await this.$store.dispatch('sendOrderStatus', obj);
            if (!res || !res.success) {
              console.log('sendOrderStatus ไม่สำเร็จ', res);
              // แจ้ง error หรือ return
              return;
            }
            const detailRes = await this.$store.dispatch('getOrderDetail', JSON.stringify([this.data.purchase_id]));
            if (detailRes && detailRes.success && detailRes.success.data && detailRes.success.data[0]) {
              Object.assign(this.data, detailRes.success.data[0]);
            } else {
              // fallback: อัปเดตสถานะเอง
              this.data.order_status = process;
              this.data.order_remarks = orderRemarks;
            }
            this.confirmDialog = false;
            this.DialogShipping = false;
          } catch (e) {
            console.log('error', e);
          }
          return;
        
        }
      }
      
    },
    detail_btn_action(param) {
      if (param === 'save') {
        console.log('detail_btn_action called', { shipping_select: this.shipping_select, parcels: this.parcels, parcelFormValid: this.parcelFormValid });
        // ตรวจสอบบริษัทขนส่ง (null-safe)
        if (this.shipping_select) {
           // ถ้าไม่ใช่จัดส่งเอง ให้ validate parcels และเช็คว่ากรอกครบ
           if (!this.isSelfShipping) {
             // ตรวจสอบทุกช่องใน parcels ว่ากรอกครบหรือไม่
             const isParcelValid = this.parcels.every(
               p => p.weight && p.width && p.length && p.height && p.qty
             );
             this.$refs.parcelForm.validate();
            if (!isParcelValid || !this.parcelFormValid) {
               // ถ้า validate ไม่ผ่าน จะมี error และขอบแดงอัตโนมัติ
               this.Error.errorShipping = '';
               this.Error.errorShipping_txt = '';
               return;
             }
           }
           this.loadding_shippop_booking = true;
           this.submit()
             .finally(() => {
               this.loadding_shippop_booking = false;
               this.DialogDetail = false; 
             });
         } else {
           console.warn('Cannot save booking: shipping_select is empty', this.shipping_select);
           this.Error.errorShipping = 'error-case';
         }
      } else {
        this.shipping_select = ''
        this.shipping_number = ''
        this.parcels = [{ weight: '', width: '', length: '', height: '', qty: 1 }]
        this.image = null
        this.file_error = false
        this.Error.errorShipping = ''
        this.Error.errorShipping_txt = ''
        this.Error.errorTracking_txt = ''
        this.Error.errorImg = ''
        this.Error.errorImg_txt = ''
        this.DialogDetail = false
      }
    },
    async printIcon () {
      // เช็คประเภทขนส่งก่อน
      if (
        this.data.shipping_name === 'Bs Express' ||
        this.data.shipping_name === 'BS_EXPRESS' ||
        this.data.shipping_channel === 'BS_EXPRESS'
      ) {
        await this.showBsLabelPopup();
        if (this.bsLabelFiles.length > 1) {
          this.showBsLabelDialog = true;
        } else {
          this.confirmText_print = 'คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่';
          this.confirmDialog_print = true;
        }
      } else {
        // กรณีจัดส่งเองหรือขนส่งอื่น
        this.confirmText_print = 'คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่';
        this.confirmDialog_print = true;
      }
    },
    // printIconBs() {
    //   // await this.showBsLabelPopup();
    //   this.showBsLabelDialog = true
    // },
    async showBsLabelPopup() {
      const res = await this.$store.dispatch('getBsExpressLabelFiles', { purchase_id: this.data.purchase_id });
      const filenames = Array.isArray(res.data.data.filename)
        ? res.data.data.filename
        : [res.data.data.filename];
      
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        this.bsLabelFiles = res.data.data;
        if (this.bsLabelFiles.length > 1) {
 
        } else if (this.bsLabelFiles.length === 1) {
          this.confirmText_print = 'คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่';
          this.confirmDialog_print = true;
        } else {
          this.bsLabelFiles = [];
          this.showBsLabelDialog = false;
        }
      } else {
        this.bsLabelFiles = [];
        this.showBsLabelDialog = false;
      }
    },
    async printBsLabelFile(fileObj) {
      console.log ('printBsLabelFile-fileObj', fileObj);
      // if (fileObj && fileObj.filenames) {
      //   fileObj.filenames.forEach(filename => {
      //     window.open(filename, '_blank');
      //   });
      // }
      const fname = fileObj.filename;
      console.log('printBsLabelFile-fname', fname);
      const url_file = await this.$store.dispatch('getUrlFile', { url_file: fname });
      window.open(url_file, '_blank');
    },
    print () {
      this.confirmPrint = false
      this.confirmDialog = false
      this.$emit('print', {})
    },
    cancel () {
      this.confirmText = ''
      this.confirmBtn = ''
      this.confirmDialog = false
      this.confirmPrint = false
    },
    onResize () {
      let x = window.innerWidth
      let y = window.innerHeight
      this.windowSize = x
      this.deviceType = window.deviceType()
    },
    addParcel() {
      // ตรวจสอบแถวสุดท้าย (หรือแถวแรกถ้ามีแค่แถวเดียว) ว่ากรอกครบหรือยัง
      const last = this.parcels[this.parcels.length - 1];
      const isValid =
        !!last.weight &&
        !!last.width &&
        !!last.length &&
        !!last.height &&
        !!last.qty;

      if (!isValid) {
        // Trigger validate ให้ขึ้น error ที่ช่องที่ยังไม่กรอก
        this.$refs.parcelForm.validate();
        return;
      }
      this.parcels.push({ weight: '', width: '', length: '', height: '', qty: 1 });
    },
    removeParcel(idx) {
      if (this.parcels.length > 1) {
        this.parcels.splice(idx, 1);
      }
    },
    maps (po, param, head) {
      const clone = structuredClone(head)
      Object.assign(clone, { page_: po + 1 })
      if (po == 0) {
        const slicedArray = param.slice(0, this.page_first)
        // this.mapObj.set(head ,slicedArray)
        clone.items = slicedArray
        this.mapObj.push(clone)
      } else {
        clone.items = param
        this.mapObj.push(clone)
      }
    },
    fromData (data) {
      let count_po = ''
      let count_item = data.items.length
      if (count_item <= this.page_first) {
        count_po = 1
      } else if (count_item - this.page_first <= this.page_ohter) {
        count_po = 2
      } else {
        var sum = (count_item - this.page_first) / this.page_ohter
        sum = Math.floor(sum) + 1
        if ((count_item - this.page_first) % this.page_ohter != 0) {
          sum = Math.floor(sum) + 1
        }
        count_po = sum
      }

      Object.assign(data, { page_count: count_po })
      if (count_po > 1) {
        this.maps(0, data.items, data)
        var a = data.items.slice(this.page_first),
          chunk
        var po = 0
        while (a.length > 0) {
          chunk = a.splice(0, this.page_ohter)
          po++
          this.maps(po, chunk, data)
        }
      } else {
        this.maps(0, data.items, data)
      }
      this.confirmDisable = true
    },
    expandParcels(parcels) {
      const result = [];
      parcels.forEach(parcel => {
        for (let i = 0; i < parcel.qty; i++) {
          result.push({
            weight: parcel.weight,
            width: parcel.width,
            length: parcel.length,
            height: parcel.height,
            qty: 1
          });
        }
      });
      return result;
    },
    generateOrderArray() {
      // สร้าง array ของ order ตามจำนวนกล่อง
      return this.expandParcels(this.parcels).map(parcel => ({
        from: {
          name: (this.from_address_select && this.from_address_select.from_name) ? this.from_address_select.from_name : this.data.sup_name,
          address: (this.from_address_select && this.from_address_select.from_address) ? this.from_address_select.from_address : this.data.sup_address,
          district: (this.from_address_select && this.from_address_select.from_district) ? this.from_address_select.from_district : this.data.sup_district,
          state: (this.from_address_select && this.from_address_select.from_state) ? this.from_address_select.from_state : this.data.sup_province,
          province: (this.from_address_select && this.from_address_select.from_province) ? this.from_address_select.from_province : this.data.sup_province,
          postcode: (this.from_address_select && this.from_address_select.from_postcode) ? String(this.from_address_select.from_postcode) : String(this.data.sup_postal),
          tel: (this.from_address_select && this.from_address_select.from_tel) ? this.from_address_select.from_tel : this.data.sup_phone
        },
        to: {
          name: this.data.cus_name,
          address: this.data.cus_address,
          district: this.data.cus_subdistrict,
          state: this.data.cus_district,
          province: this.data.cus_province,
          postcode: String(this.data.cus_postal),
          tel: this.data.cus_phone
        },
        parcel: {
          name: '-',
          weight: String(parcel.weight),
          width: String(parcel.width),
          length: String(parcel.length),
          height: String(parcel.height)
        },
        courier_code: this.shipping_select.shipping_name === 'Bs Express'
                  ? 'BS_EXPRESS'
                  : this.shipping_select.shipping_name || this.data.shipping_name
      }));
    },
    resetDialogDetail() {
      const prevFromAddress = this.from_address_select;
      this.shippingSelectKey++;
      this.shipping_select = null;
      this.shipping_number = '';
      this.parcels = [{ weight: '', width: '', length: '', height: '', qty: 1 }];
      this.image = null;
      this.file_error = false;
      this.Error.errorShipping = '';
      this.Error.errorShipping_txt = '';
      this.Error.errorTracking_txt = '';
      this.Error.errorImg = '';
      this.Error.errorImg_txt = '';
      this.dialogInvoice = false;
      this.invoiceFile = null;
      this.invoicePreview = null;
      this.invoiceError = '';
      this.parcelFormValid = false;
      if (this.$refs.parcelForm) {
        this.$refs.parcelForm.reset();
        this.$refs.parcelForm.resetValidation && this.$refs.parcelForm.resetValidation();
      }
      if (this.data) {
        this.data.shipping_name = '';
        this.data.shipping_channel = '';
        this.data.shipping_code = '';
        this.data.tracking_code = '';
      }
      if (prevFromAddress) {
        this.from_address_select = prevFromAddress;
      }
    }
  }
}
</script>
<style>
.error-case {
  border: 1px solid red;
  font-size: 12px;
  height: 36px;
  font-family: 'Bai Jamjuree', sans-serif;
}

.disabled-select .v-input__control .v-input__slot {
  background-color: #f5f5f5 !important;
}

.disabled-select .v-select__slot {
  background-color: #f5f5f5 !important;
}

.hide {
  display: none;
}

.btn {
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 4px;
}

.btn-large {
  padding: 11px 19px;
  font-size: 17.5px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.parcel-field.v-input--is-disabled .v-input__slot {
  background-color: #e0e0e0 !important;
  border: 1px solid #cccccc !important;
}

.parcel-field.v-input--is-disabled input {
  background-color: #e0e0e0 !important;
  color: #757575 !important;
  cursor: not-allowed !important;
}

.parcel-field.v-text-field--solo.v-input--is-disabled .v-input__slot {
  background-color: #e0e0e0 !important;
  box-shadow: none !important;
}

.shipping-tracking-input-wrap {
  overflow: visible !important;
  padding-bottom: 2px;
}
.shipping-tracking-field.v-input,
.shipping-tracking-field .v-input__control,
.shipping-tracking-field .v-input__slot {
  overflow: visible !important;
}
</style>
